/**
 * The urgent exception path in one step (IN-1718, Flow 2).
 *
 * Issuing a no-sign-in link normally means: pick the campaign, add the
 * creator, set the price, then issue the link. For a "pay them in the next two
 * hours" campaign that is three screens before the creator sees a form. This
 * shapes the payloads for doing it in one submit — add the creator, then issue
 * the link against the row that comes back — using the endpoints that already
 * exist.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function amount(value) {
  const parsed = parseFloat(String(value ?? '').trim());
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * `picked` is an existing creator from master data, or null for someone new.
 * Returns `{field: message}`; empty means valid.
 */
export function validateQuickInvite(form, picked) {
  const values = form || {};
  const errors = {};

  if (!picked) {
    if (!String(values.name || '').trim()) {
      errors.name = "Enter the creator's name, or pick one from the list.";
    }
    if (!EMAIL_RE.test(String(values.email || '').trim())) {
      errors.email = 'Enter a valid email address for the creator.';
    }
  }

  if (!String(values.reason || '').trim()) {
    errors.reason = 'Say why this invoice skips sign-in. Exception use is reported.';
  }

  const price = String(values.influencer_final_price ?? '').trim();
  if (price !== '') {
    const parsed = amount(price);
    if (parsed === null || parsed <= 0) {
      errors.influencer_final_price = 'Enter the agreed payout as a number, or leave it blank.';
    }
  }

  return errors;
}

/**
 * The two request bodies, in the order they are sent: the creator goes onto
 * the campaign first, then the link is issued for the row it returns.
 */
export function quickInvitePayloads(form, picked) {
  const values = form || {};
  const payout = amount(values.influencer_final_price);
  const billing = amount(values.final_price);

  const creator = picked
    ? { influencer_id: picked.id }
    : { name: String(values.name || '').trim(), email: String(values.email || '').trim() };

  if (payout !== null) creator.influencer_final_price = payout;
  if (billing !== null) creator.final_price = billing;
  // Locking is the point of setting a price here; with no price there is
  // nothing to lock.
  creator.locked = payout !== null;

  return {
    creator,
    link: {
      reason: String(values.reason || '').trim(),
      expires_in_days: values.expires_in_days,
    },
  };
}
